<i18n lang="yaml">
en:
  title: 'Network'
  subtitle: 'Build a&nbsp;network configuration at&nbsp;your request: add a&nbsp;subnet, configure routing, create network gateways and other features.'
  cardText1: '3 TB free external traffic'
  cardText2: 'Network connections with 1&nbsp;Gbps of&nbsp;bandwidth'
  cardText3: 'Different sizes of&nbsp;Public and private subnetworks'
  cardText4: 'Floating IP&nbsp;addresses'
ru:
  title: 'Сеть'
  subtitle: 'Построение сетевой конфигурации по вашим требованиям: добавление подсети, настройка маршрутизации, создание сетевых шлюзов и другие возможности.'
  cardText1: '3 ТБ трафика бесплатно'
  cardText2: 'Пропускная способность канала — 1 Гбит/c'
  cardText3: 'Публичные и приватные подсети разных размеров'
  cardText4: 'Плавающие IP-адреса'
</i18n>

<template>
  <s-section
    :title="$t('title')"
    :subtitle="$t('subtitle')"
    class="pb-0"
  >
    <div class="row">
      <div class="col-xl-3">
        <div class="cloud-servers-network__item">
          <img
            class="cloud-servers-network__icon"
            :src="require('~/assets/images/components/single/cloud-servers-network/traffic.svg?inline').default"
            alt=""
          >
          <h3
            class="cloud-servers-network__title"
            v-html="$t('cardText1')"
          ></h3>
        </div>
      </div>
      <div class="col-xl-3">
        <div class="cloud-servers-network__item">
          <img
            class="cloud-servers-network__icon"
            :src="require('~/assets/images/components/single/cloud-servers-network/throughput.svg?inline').default"
            alt=""
          >
          <h3
            class="cloud-servers-network__title"
            v-html="$t('cardText2')"
          ></h3>
        </div>
      </div>
      <div class="col-xl-3">
        <div class="cloud-servers-network__item">
          <img
            class="cloud-servers-network__icon"
            :src="require('~/assets/images/components/single/cloud-servers-network/subnets.svg?inline').default"
            alt=""
          >
          <h3
            class="cloud-servers-network__title"
            v-html="$t('cardText3')"
          ></h3>
        </div>
      </div>
      <div class="col-xl-3">
        <div class="cloud-servers-network__item">
          <img
            class="cloud-servers-network__icon"
            :src="require('~/assets/images/components/single/cloud-servers-network/ip-addresses.svg?inline').default"
            alt=""
          >
          <h3
            class="cloud-servers-network__title"
            v-html="$t('cardText4')"
          ></h3>
        </div>
      </div>
    </div>
  </s-section>
</template>

<script>
export default {
  name: 'CloudServersNetwork'
}
</script>

<style lang="scss">
.cloud-servers-network__item {
  margin-bottom: 60px;
}

.cloud-servers-network__icon {
  margin-bottom: 24px;
  width: auto;
  max-height: 72px;

  @media (max-width: $breakpoint-lg) {
    max-height: 64px;
  }

  @media (max-width: $breakpoint-sm) {
    max-height: 48px;
  }
}
</style>